if (!customElements.get("pickup-availability")) {
  class e extends HTMLElement {
    constructor() {
      if ((super(), !this.hasAttribute("available"))) return;
      (this.refreshHandler = this.handleRefreshBtnClick.bind(this)),
        (this.unavailableHtml = this.querySelector(
          "template"
        ).content.firstElementChild.cloneNode(!0)),
        this.getAvailability(this.dataset.variantId);
    }
    handleRefreshBtnClick() {
      this.getAvailability(this.dataset.variantId);
    }
    async getAvailability(e) {
      let { rootUrl: t } = this.dataset;
      t.endsWith("/") || (t = `${t}/`);
      try {
        let i = await fetch(
          `${t}variants/${e}/?section_id=pickup-availability`
        );
        if (!i.ok) throw Error(i.status);
        let r = document.createElement("template");
        (r.innerHTML = await i.text()),
          this.renderPickupInfo(r.content.querySelector(".shopify-section"));
      } catch (a) {
        let s = this.querySelector(".js-refresh");
        s && s.removeEventListener("click", this.refreshHandler),
          this.renderUnavailableMsg();
      }
    }
    renderPickupInfo(e) {
      let t = document.querySelector(".js-pickup-drawer");
      if ((t && t.remove(), !e.querySelector(".pickup-status"))) {
        (this.innerHTML = ""), this.removeAttribute("available");
        return;
      }
      this.setAttribute("available", ""),
        (this.innerHTML = e.querySelector(".pickup-status").outerHTML),
        document.body.appendChild(e.querySelector(".js-pickup-drawer"));
      let i = this.querySelector(".js-show-pickup-info");
      i &&
        i.addEventListener("click", () => {
          document.querySelector(".js-pickup-drawer").open(i);
        });
    }
    renderUnavailableMsg() {
      (this.innerHTML = ""),
        this.appendChild(this.unavailableHtml),
        this.querySelector(".js-refresh").addEventListener(
          "click",
          this.refreshHandler
        );
    }
  }
  customElements.define("pickup-availability", e);
}
